import { connect } from 'react-redux';
import { HOUSE_MATERIALS } from '../../../../constants/filters';
import { EHouseMaterial } from '../../../../types/filters';
import { changeHouseMaterialFilter } from '../../../../store/filters/actions';
import { mapDispatchToPropsCreator, mapStateToPropsCreator } from '../creators';
import { createExtraFilter, IExtraFilterProps } from '../helpers';

export const HouseMaterialLongNames: { [key: string]: string } = {
  aerocreteBlock: 'Материал дома: газобетонный блок',
  boards: 'Материал дома: щитовой',
  brick: 'Материал дома: кирпичный',
  foamConcreteBlock: 'Материал дома: пенобетонный блок',
  monolith: 'Материал дома: монолитный',
  wood: 'Материал дома: деревянный',
};

const HouseMaterialsFilter = createExtraFilter<EHouseMaterial>(HOUSE_MATERIALS);

type THouseMaterialsFilterProps = IExtraFilterProps<EHouseMaterial>;

export const HouseMaterialsFilterContainer = connect<
  Pick<THouseMaterialsFilterProps, 'selected'>,
  Pick<THouseMaterialsFilterProps, 'toggle'>
>(
  mapStateToPropsCreator<EHouseMaterial>('houseMaterialType'),
  mapDispatchToPropsCreator<EHouseMaterial>(changeHouseMaterialFilter),
)(HouseMaterialsFilter);
